import { staffService } from '../../helpers/services/staff.service';
import i18n from '@/i18n'
import router from '@/router/index'
import { sharedHelper } from '@/utils'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const STAFF_MODULE = "staff";

// define action 
export const GET_ALL_STAFFS = 'getAllStaff';
export const UPDATE_STAFF_STATUS = 'updateStaffStatus';
export const GET_STAFF = 'getStaff';
export const GET_STAFF_PROFILE = 'getStaffProfile';
export const UPDATE_STAFF = 'updateStaff';
export const UPDATE_STAFF_PROFILE = 'updateStaffProfile';
export const UNLOCK_STAFF = 'unlockStaff';
export const CREATE_STAFF = 'createStaff';

// define mutation
const REQUESTING = "requesting";
const ALL_STAFF_SUCCESS = "allStaffSuccess";
const SUCCESS_REDIRECT_INTO_COMPANY = "successRedirectIntoCompany";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_STAFF_SUCCESS = "getStaffSuccess";
const UPDATE_STAFF_SUCCESS = "updateStaffSuccess";

export const actions = {

    // eslint-disable-next-line no-unused-vars
    [GET_ALL_STAFFS]({ commit }, { filter }) {
        staffService
            .getAllStaffs(filter)
            .then(
                (result) => {
                    commit(ALL_STAFF_SUCCESS, { data: result })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_STAFF_STATUS]({ dispatch, commit }, { filter, data }) {
        staffService.updateStaffStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_STAFFS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_STAFF]({ commit }, { id }) {
        await staffService
            .getStaff(id)
            .then(
                (result) => {
                    commit(GET_STAFF_SUCCESS, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [GET_STAFF_PROFILE]({ commit }) {
        staffService
            .getStaffProfile()
            .then(
                (result) => {
                    commit(GET_STAFF_SUCCESS, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },


    // eslint-disable-next-line no-unused-vars
    [UPDATE_STAFF]({ commit }, { data }) {
        commit(REQUESTING);
        staffService
            .updateStaff(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.staff')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(UPDATE_STAFF_SUCCESS);
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_STAFF_PROFILE]({ commit, dispatch }, { data }) {
        commit(REQUESTING);
        staffService
            .updateStaffProfile(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS);
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.profile')]);
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_STAFF_PROFILE)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UNLOCK_STAFF]({ dispatch, commit }, { id }) {
        commit(REQUESTING);
        staffService.unlockStaff(id)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS);
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_STAFF, { id })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_STAFF]({ commit }, { redirectToCompany, data }) {
        commit(REQUESTING);
        try {
        staffService
            .createStaff(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.staff')]);
                    sharedHelper.alertSuccessMessage(message)
                    if (redirectToCompany) { 
                        commit(SUCCESS_REDIRECT_INTO_COMPANY);
                    }
                    else {
                        commit(UPDATE_STAFF_SUCCESS);
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
        }
    },

};

export const mutations = {
    [ALL_STAFF_SUCCESS](state, { data }) {
        let d = data.data

        state.list.data = []
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        if (data.success) {
            let list = []

            d.forEach((x) => {
                list.push({
                    id: x.uuid,
                    firstName: x.first_name,
                    lastName: x.last_name,
                    title: x.title,
                    email: x.email,
                    phoneCode: x.phone_code,
                    phone: x.phone == null ? '' : x.phone,
                    phoneISO: x.phone_iso,
                    loginAttempt: x.login_attempt,
                    isLocked: x.is_locked,
                    isActive: x.is_active,
                    address1: x.address_1,
                    address2: x.address_2,
                    address3: x.address_3,
                    postcode: x.postcode,
                    city: x.city,
                    state: x.state,
                    calendarColor: x.calendar_color ? '#' + x.calendar_color : '#000000',
                    emergencyContactPersonFirstName: x.emergency_contact_person_first_name,
                    emergencyContactPersonLastName: x.emergency_contact_person_last_name,
                    emergencyContactPersonPhone: x.emergency_contact_person_phone == null ? "" : x.emergency_contact_person_phone,
                    emergencyContactPersonPhoneCode: x.emergency_contact_person_phone_code,
                    emergencyContactPersonPhoneISO: x.emergency_contact_person_phone_iso,
                    emergencyContactPersonEmail: x.emergency_contact_person_email,
                    emergencyContactPersonAddress1: x.emergency_contact_person_address_1,
                    emergencyContactPersonAddress2: x.emergency_contact_person_address_2,
                    emergencyContactPersonAddress3: x.emergency_contact_person_address_3,
                    emergencyContactPersonPostcode: x.emergency_contact_person_postcode,
                    emergencyContactPersonCity: x.emergency_contact_person_city,
                    emergencyContactPersonState: x.emergency_contact_person_state,
                    emailVerifiedAt: x.email_verified_at,
                    dateJoin: x.date_join,
                    birthday: x.birthday,
                    salary: x.salary,
                    displayImageURL: x.display_image_url,
                    // roleId: x.roles[0].uuid,
                    location: x.location,
                    newLocation: x.new_location,
                    staffShift: x.staff_shifts,
                })
            })

            state.list.data = list
        }
    },
    [SUCCESS](state) {
        state.status = {};
    },
    [SUCCESS_REDIRECT_INTO_COMPANY](state) {
        state.status = {};
        router.push({ name: "Company-listing" })
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUESTING](state) {
        state.status = { processing: true };
    },
    [UPDATE_STAFF_SUCCESS](state) {
        state.status = {};
        router.push({ name: "Staff-listing" })
    },
    [GET_STAFF_SUCCESS](state, data) {
        let x = data.data

        state.details = {
            id: x.uuid,
            firstName: x.first_name,
            lastName: x.last_name,
            title: x.title,
            email: x.email,
            phoneCode: x.phone_code,
            phone: x.phone == null ? '' : x.phone,
            phoneISO: x.phone_iso,
            loginAttempt: x.login_attempt,
            isLocked: x.is_locked,
            isActive: x.is_active,
            address1: x.address_1,
            address2: x.address_2,
            address3: x.address_3,
            postcode: x.postcode,
            city: x.city,
            state: x.state,
            locationID: x.location != null ? {
                value: x.location.uuid,
                text: x.location.name
            } : '',
            calendarColor: x.calendar_color ? '#' + x.calendar_color : '#000000',
            emergencyContactPersonFirstName: x.emergency_contact_person_first_name,
            emergencyContactPersonLastName: x.emergency_contact_person_last_name,
            emergencyContactPersonPhone: x.emergency_contact_person_phone == null ? "" : x.emergency_contact_person_phone,
            emergencyContactPersonPhoneCode: x.emergency_contact_person_phone_code,
            emergencyContactPersonPhoneISO: x.emergency_contact_person_phone_iso,
            emergencyContactPersonEmail: x.emergency_contact_person_email,
            emergencyContactPersonAddress1: x.emergency_contact_person_address_1,
            emergencyContactPersonAddress2: x.emergency_contact_person_address_2,
            emergencyContactPersonAddress3: x.emergency_contact_person_address_3,
            emergencyContactPersonPostcode: x.emergency_contact_person_postcode,
            emergencyContactPersonCity: x.emergency_contact_person_city,
            emergencyContactPersonState: x.emergency_contact_person_state,
            emailVerifiedAt: x.email_verified_at,
            dateJoin: x.date_join,
            birthday: x.birthday,
            salary: x.salary,
            displayImageURL: x.display_image_url,
            // roleId: x.roles[0].uuid,
            location: x.location,
            newLocation: x.new_location,
            staffShift: x.staff_shifts,
        }
    },
}


